<div class="title">
  <h1 class="flex flex-row text-xl md:text-2xl font-app-bold mb-5 md:mb-10 md:ml-16 mt-4 md:-mt-8 p-1">
    {{ "header.contact" | translate }}
  </h1>
</div>

<div
  class="bg-white flex rounded-lg shadow-none p-3 border-l-8 border-primary_text md:border-none mt-4 mx-auto mb-4 w-11/12"
  *ngIf="agreementTypes === AgreementTypes.Policy">
  <div class="text-sm md:flex md:items-center md:justify-between w-full md:pr-2">
    <div class="mb-3 md:mb-0 md:mr-2 flex md:items-center items-start">
      <i class="pi pi-info-circle mr-2 text-primary_text font-bold text-lg"></i>
      {{ "contactUsPolicyNote.note" | translate }}
    </div>
    <div class="flex items-baseline justify-center md:mt-2">
      <i class="pi pi-arrow-right mr-1 mb-3 text-xs"></i>
      <span
        class="font-app-bold cursor-pointer md:ml-0"
        (click)="onReturnToPolicy()">
        {{ "contactUsPolicyNote.returnToPolicy" | translate }}
      </span>
    </div>
  </div>
</div>
